import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { UserProfileResource } from 'util/resources/UserProfile';
import { EmployerResource } from 'util/resources/Employer';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class ConversationMemberAttributes {
  id: string = null;
  conversationId: string = null;
  messageableId: string = null;
  messageableType: string = null;
  createdAt: string = null;
  updatedAt: string = null;
}

export class ConversationMemberBelongsTo {
  conversation: () => ConversationMemberResource = () => new ConversationMemberResource();
}

export class ConversationMemberBelongsToInverseOfConversationMemberships {
  messageable: () => UserProfileResource | EmployerResource = () => null;
}

export class ConversationMemberHasOne {}
export class ConversationMemberHasMany {}

/**
 * Utility interfaces
 */
export interface ConversationMemberMethods {}

export interface ConversationMemberInterface
  extends ConversationMemberAttributes,
    ConversationMemberBelongsTo,
    ConversationMemberBelongsToInverseOfConversationMemberships,
    ConversationMemberType {}

type ConversationMemberType = GConstructor<ConversationMemberInterface>;

export interface ConversationMemberResource
  extends Base<ConversationMemberAttributes>,
    ConversationMemberInterface,
    ConversationMemberMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<ConversationMemberAttributes>({
    queryName: 'conversation_members',
    className: 'ConversationMember',
    AttributesClass: ConversationMemberAttributes,
    BelongsToClasses: [
      {
        Klass: ConversationMemberBelongsTo,
      },
      {
        Klass: ConversationMemberBelongsToInverseOfConversationMemberships,
        options: { polymorphic: true, inverseOf: 'conversationMemberships' },
      },
    ],
  });

export const ConversationMemberResourceClass = <TBase extends ConversationMemberType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements ConversationMemberMethods {};

export class ConversationMemberResource extends ClassExtender<ConversationMemberInterface>(
  BaseClass,
  ConversationMemberResourceClass,
) {}

/**
 * Resource instance
 */
export const ConversationMember = APILibrary.createResource<ConversationMemberResource>(
  ConversationMemberResource,
);
